module.exports = __webpack_public_path__ + "static/media/13.62a96f01.jpg";